<script>

    import { createEventDispatcher } from 'svelte';
    import Modal from "../UI/Modal.svelte";
    import Button from "../UI/Button.svelte";

    const dispatch = createEventDispatcher()
    

    function cancelModal() {
        dispatch('cancel')
    }
    export let plantName;
    $: console.log(plantName);

    var title =`Take Care of Your ${plantName} Plants`
    </script>

    
    <Modal title={title} on:cancel>  
        <p>Growing plants takes more than time and sunshine.</p>
        <div slot="footer">
            <Button 
            mode= "outline" 
            type= "button" 
            on:click={cancelModal}>
            
            back</Button>
        </div>
    </Modal>